const cities = [
  //  ARGENTINA
  {
    id: 'bariloche',
    country: 'AR',
    bd_city_id: 1,
    civitatis_id: 'bariloche',
    main_city_search: true,
    keywords: 'Bariloche, Rio Negro, Argentina. Lago Nahuel Huapi, Cerro Otto, Llao Llao',
    geometry: {
      location: {
        lat: -41.1334722,
        lng: -71.3102778,
      },
    },
  },
  {
    id: 'buenos-aires',
    country: 'AR',
    bd_city_id: 2,
    transfer_type_is_ride: true,
    civitatis_id: 'buenos-aires',
    main_city_search: true,
    keywords: 'CABA, Buenos Aires, Retiro, Recoleta, Palermo, San Telmo, Microcentro, Puerto Maderos',
    geometry: {
      location: {
        lat: -34.6036844,
        lng: -58.3815591,
      },
    },
  },
  {
    id: 'cordoba',
    country: 'AR',
    bd_city_id: 3,
    civitatis_id: 'cordoba-argentina',
    main_city_search: true,
    keywords: 'Ciudad de Córdoba, Córdoba, Argentina.',
    geometry: {
      location: {
        lat: -31.42008329999999,
        lng: -64.1887761,
      },
    },
  },
  {
    id: 'calafate',
    country: 'AR',
    bd_city_id: 4,
    civitatis_id: 'el-calafate',
    keywords: 'El Calafate, Santa Cruz, Argentina',
    geometry: {
      location: {
        lat: -50.34506999999999,
        lng: -72.274544,
      },
    },
  },
  {
    id: 'mar-del-plata',
    country: 'AR',
    bd_city_id: 5,
    keywords: 'Mar del Plata. Costa Argentina, La Feliz, Museo MAR, Playa Grande, Bristol, Torreón del Monje, Playa Varese.',
    geometry: {
      location: {
        lat: -38.0054771,
        lng: -57.5426106,
      },
    },
  },
  {
    id: 'mendoza',
    country: 'AR',
    bd_city_id: 6,
    civitatis_id: 'mendoza',
    main_city_search: true,
    keywords: 'Gran Mendoza, Ciudad de Mendoza, Godoy Cruz, Las Heras, Guaymallén, Maipú, Luján de Cuyo. Malbec, Villavicencio',
    geometry: {
      location: {
        lat: -32.8894587,
        lng: -68.8458386,
      },
    },
  },
  {
    id: 'necochea',
    country: 'AR',
    bd_city_id: 72,
    keywords: 'Necochea, Costa Atlántica, Buenos Aires, Argentina',
    geometry: {
      location: {
        lat: -38.5850144,
        lng: -58.72702469999999,
      },
    },
  },
  {
    id: 'parana',
    country: 'AR',
    bd_city_id: 7,
    keywords: 'Paraná, Entre Ríos, Parque Urquiza, Playa El Parque, Playa Thompson, Región del Litoral.',
    geometry: {
      location: {
        lat: -31.7413197,
        lng: -60.51154709999999,
      },
    },
  },
  {
    id: 'pinamar',
    country: 'AR',
    bd_city_id: 8,
    keywords: 'Pinamar, Costa Atlántica Argentina, Avenida Arquitecto Jorge Bunge, Playa Argentina',
    geometry: {
      location: {
        lat: -37.1145662,
        lng: -56.86070549999999,
      },
    },
  },
  {
    id: 'posadas',
    country: 'AR',
    bd_city_id: 9,
    keywords: 'Posadas Misiones, río Paraná',
    geometry: {
      location: {
        lat: -27.3621374,
        lng: -55.90087459999999,
      },
    },
  },
  {
    id: 'puerto-iguazu',
    country: 'AR',
    bd_city_id: 10,
    civitatis_id: 'puerto-iguazu',
    keywords: 'Puerto Iguazú, Misiones, Cataratas del Iguazú',
    geometry: {
      location: {
        lat: -25.5971635,
        lng: -54.578599,
      },
    },
  },
  {
    id: 'puerto-madryn',
    country: 'AR',
    bd_city_id: 10,
    civitatis_id: 'puerto-madryn',
    keywords: 'Puerto Madryn, Chubut, Argentina',
    geometry: {
      location: {
        lat: -42.76362169999999,
        lng: -65.03483109999999,
      },
    },
  },
  {
    id: 'salta',
    country: 'AR',
    bd_city_id: 11,
    civitatis_id: 'salta',
    keywords: 'Salta, Salta La Linda, Argentina. Tren a las Nubes, Cafayate, cerro San Bernardo, Cachi, Dique Cabra Corral, Museo de Arqueología de Alta Montaña, MAAM',
    geometry: {
      location: {
        lat: -24.7821269,
        lng: -65.4231976,
      },
    },
  },
  {
    id: 'san-juan',
    country: 'AR',
    bd_city_id: 12,
    civitatis_id: 'san-juan-argentina',
    keywords: 'San Juan, Provincia de San Juan, Argentina',
    geometry: {
      location: {
        lat: -31.5351074,
        lng: -68.5385941,
      },
    },
  },
  {
    id: 'san-martin-de-los-andes',
    country: 'AR',
    bd_city_id: 13,
    civitatis_id: 'san-martin-andes',
    keywords: 'San Martín de los Andes, Patagonia, Argentina, Parque Nacional Lanín, lago Lácar',
    geometry: {
      location: {
        lat: -40.1572103,
        lng: -71.3524436,
      },
    },
  },
  {
    id: 'tucuman',
    country: 'AR',
    bd_city_id: 14,
    civitatis_id: 'san-miguel-tucuman',
    keywords: 'San Miguel de Tucumán, Casa de Gobierno, Museo Casa Histórica de la Independencia',
    geometry: {
      location: {
        lat: -26.8082848,
        lng: -65.2175903,
      },
    },
  },
  {
    id: 'san-rafael',
    country: 'AR',
    bd_city_id: 15,
    keywords: 'San Rafael, Mendoza, Catedral San Rafael Arcángel, Vinos Malbec, presa Los Reyunos, Cañón del Atuel',
    geometry: {
      location: {
        lat: -34.6128922,
        lng: -68.3390622,
      },
    },
  },
  {
    id: 'jujuy',
    country: 'AR',
    bd_city_id: 16,
    civitatis_id: 'san-salvador-de-jujuy',
    keywords: 'San Salvador de Jujuy, Jujuy, Argentina. Plaza Belgrano, Quebrada de Humahuaca, Purmamarca, Tilcara, Salinas Grandes',
    geometry: {
      location: {
        lat: -24.1857864,
        lng: -65.2994767,
      },
    },
  },
  {
    id: 'santa-fe',
    country: 'AR',
    bd_city_id: 17,
    keywords: 'Santa Fe, Santa Fe de la Vera Cruz, río Paraná, río Salado, puente colgante',
    geometry: {
      location: {
        lat: -31.6401653,
        lng: -60.70469549999999,
      },
    },
  },
  {
    id: 'ushuaia',
    country: 'AR',
    bd_city_id: 18,
    civitatis_id: 'ushuaia',
    keywords: 'Ushuaia, Tierra del Fuego. El Fin del Mundo. Montes Martial, el canal Beagle.',
    geometry: {
      location: {
        lat: -54.8019121,
        lng: -68.3029511,
      },
    },
  },
  {
    id: 'villa-la-angostura',
    country: 'AR',
    bd_city_id: 19,
    civitatis_id: 'villa-la-angostura',
    keywords: 'Villa la Angostura, Lago Nahuel Huapi, Patagonia argentina, Parque Nacional Los Arrayanes, cerro Bayo, camino Siete Lagos',
    geometry: {
      location: {
        lat: -40.7627426,
        lng: -71.6417984,
      },
    },
  },

  //  MÉXICO
  {
    id: 'cabo-san-lucas',
    country: 'MX',
    bd_city_id: 58,
    civitatis_id: 'los-cabos',
    keywords: 'Cabo San Lucas, México, Baja California, Santuario de Guadalupe, Playa El Médano, Fin de la Tierra, Playa del Amor, El Arco, océano Pacífico, San José del Cabo',
    geometry: {
      location: {
        lat: 22.8905327,
        lng: -109.9167371,
      },
    },
  },
  {
    id: 'cancun',
    country: 'MX',
    bd_city_id: 59,
    civitatis_id: 'cancun',
    main_city_search: true,
    keywords: 'Cancun, México, Caribe, Playas, Zona Hotelera, Quintana Roo, Benito Juárez, Aeropuerto Internacional de Cancún',
    geometry: {
      location: {
        lat: 21.161908,
        lng: -86.8515279,
      },
    },
  },
  {
    id: 'cdmx',
    country: 'MX',
    bd_city_id: 60,
    civitatis_id: 'ciudad-de-mexico',
    main_city_search: true,
    keywords: 'Ciudad de México, CDMX, Zócalo, Tenochtitlán, Ángel de la Independencia, Chapultepec, Coyoacán, Condesa, Polanco, Basílica de Guadalupe',
    geometry: {
      location: {
        lat: 19.4326077,
        lng: -99.133208,
      },
    },
  },
  {
    id: 'guadalajara',
    country: 'MX',
    bd_city_id: 61,
    civitatis_id: 'guadalajara',
    main_city_search: true,
    keywords: 'Guadalajara, México, Jallisco, Valle de Atemajac, Puerto Vallarta, La Ciudad de las Rosas',
    geometry: {
      location: {
        lat: 20.6596988,
        lng: -103.3496092,
      },
    },
  },
  {
    id: 'merida',
    country: 'MX',
    bd_city_id: 62,
    civitatis_id: 'merida-mexico',
    keywords: 'Mérida, Yucatán , México',
    geometry: {
      location: {
        lat: 20.9673702,
        lng: -89.5925857,
      },
    },
  },
  {
    id: 'playa-del-carmen',
    country: 'MX',
    bd_city_id: 63,
    civitatis_id: 'playa-del-carmen',
    main_city_search: true,
    keywords: 'Playa del Carmen, México, Caribe, Playas, Riviera Maya, Quintana Roo',
    geometry: {
      location: {
        lat: 20.6295586,
        lng: -87.0738851,
      },
    },
  },
  {
    id: 'san-miguel-cozumel',
    country: 'MX',
    bd_city_id: 65,
    civitatis_id: 'cozumel',
    keywords: 'San Miguel de Cozumel, México, Caribe, Playas,  isla de Cozumel, Riviera Maya, Quintana Roo',
    geometry: {
      location: {
        lat: 20.5071703,
        lng: -86.9446237,
      },
    },
  },
  {
    id: 'tulum',
    country: 'MX',
    bd_city_id: 66,
    civitatis_id: 'tulum',
    keywords: 'Tulum, México, Caribe, Playas, Riviera Maya, Quintana Roo, ciudad maya de Tulum',
    geometry: {
      location: {
        lat: 20.2114185,
        lng: -87.46535019999999,
      },
    },
  },

  //  COLOMBIA
  {
    id: 'bogota',
    country: 'CO',
    bd_city_id: 35,
    civitatis_id: 'bogota',
    main_city_search: true,
    keywords: 'Bogotá, Colombia',
    geometry: {
      location: {
        lat: 4.6245251,
        lng: -74.0658653,
      },
    },
  },
  {
    id: 'medellin',
    country: 'CO',
    bd_city_id: 37,
    civitatis_id: 'medellin',
    main_city_search: true,
    keywords: 'Medellín, Colombia',
    geometry: {
      location: {
        lat: 6.2476376,
        lng: -75.56581530000001,
      },
    },
  },
  {
    id: 'santa-marta',
    country: 'CO',
    bd_city_id: 39,
    civitatis_id: 'santa-marta',
    keywords: 'Santa Marta, Colombia',
    geometry: {
      location: {
        lat: 11.2403547,
        lng: -74.2110227,
      },
    },
  },
  {
    id: 'cartagena',
    country: 'CO',
    bd_city_id: 36,
    civitatis_id: 'cartagena-de-indias',
    keywords: 'Cartagena, Provincia de Cartagena, Bolívar, Colombia',
    geometry: {
      location: {
        lat: 10.3932277,
        lng: -75.4832311,
      },
    },
  },
  {
    id: 'san-andres',
    country: 'CO',
    bd_city_id: 38,
    civitatis_id: 'san-andres',
    keywords: 'San Andrés, San Andrés y Providencia, Colombia',
    geometry: {
      location: {
        lat: 12.576855,
        lng: -81.705052,
      },
    },
  },

  //  CHILE
  {
    id: 'santiago',
    country: 'CL',
    bd_city_id: 32,
    civitatis_id: 'santiago-de-chile',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Santiago de Chile, Región Metropolitana, Chile',
    geometry: {
      location: {
        lat: -33.4488897,
        lng: -70.6692655,
      },
    },
  },
  {
    id: 'valparaiso',
    country: 'CL',
    bd_city_id: 33,
    civitatis_id: 'valparaiso',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Valparaíso, Chile',
    geometry: {
      location: {
        lat: -33.047238,
        lng: -71.61268849999999,
      },
    },
  },
  {
    id: 'vina-del-mar',
    country: 'CL',
    bd_city_id: 34,
    civitatis_id: 'vina-mar',
    main_city_search: true,
    keywords: 'Viña del Mar, Valparaíso, Chile',
    geometry: {
      location: {
        lat: -33.0153481,
        lng: -71.55002759999999,
      },
    },
  },

  //  REPÚBLICA DOMINICANA
  {
    id: 'santo-domingo',
    country: 'DO',
    bd_city_id: 41,
    civitatis_id: 'santo-domingo',
    main_city_search: true,
    keywords: 'Santo Domingo, Capital de República Dominicana, Caribe, Zona Colonial',
    geometry: {
      location: {
        lat: 18.4860575,
        lng: -69.93121169999999,
      },
    },
  },

  //  ECUADOR
  {
    id: 'quito',
    country: 'EC',
    bd_city_id: 43,
    civitatis_id: 'quito',
    main_city_search: true,
    keywords: 'Quito, San Francisco de Quito, Capital de Ecuador, Provincia de Pichincha, los Andes, Antigua ciudad inca, América del Sur.',
    geometry: {
      location: {
        lat: -0.1806532,
        lng: -78.4678382,
      },
    },
  },
  {
    id: 'guayaquil',
    country: 'EC',
    bd_city_id: 42,
    civitatis_id: 'guayaquil',
    main_city_search: true,
    keywords: 'Guayaquil, Santiago de Guayaquil, Ecuador, Provincia del Guayas, Puerto a playas del Pacífico y a las Islas Galápagos.',
    geometry: {
      location: {
        lat: -2.1894128,
        lng: -79.8890662,
      },
    },
  },

  //  COSTA RICA
  {
    id: 'san-jose',
    country: 'CR',
    bd_city_id: 40,
    civitatis_id: 'san-jose',
    main_city_search: true,
    keywords: 'San José, Capital de Costa Rica, Valle Central',
    geometry: {
      location: {
        lat: 9.9280694,
        lng: -84.0907246,
      },
    },
  },

  //  PERÚ
  {
    id: 'lima',
    country: 'PE',
    bd_city_id: 70,
    civitatis_id: 'lima',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Lima, Capital del Perú, costa del Pacífico',
    geometry: {
      location: {
        lat: -12.0463731,
        lng: -77.042754,
      },
    },
  },
  {
    id: 'cusco',
    country: 'PE',
    bd_city_id: 68,
    civitatis_id: 'cusco',
    main_city_search: true,
    keywords: 'Cusco, Cuzco, ciudad de los Andes peruanos, capital del Imperio Inca, Machu Picchu',
    geometry: {
      location: {
        lat: -13.53195,
        lng: -71.96746259999999,
      },
    },
  },
  {
    id: 'iquitos',
    country: 'PE',
    bd_city_id: 69,
    main_city_search: true,
    keywords: 'Iquitos Perú, Amazonas, distrito de Belén',
    geometry: {
      location: {
        lat: -3.7437644,
        lng: -73.2515532,
      },
    },
  },

  //  PANAMÁ
  {
    id: 'panama',
    country: 'PA',
    bd_city_id: 67,
    civitatis_id: 'ciudad-de-panama',
    main_city_search: true,
    keywords: 'Panamá, Canal de Panamá, Océano Atlántico, Océano Pacífico, Ruta marítima ',
    geometry: {
      location: {
        lat: 8.961824499999999,
        lng: -79.5344824,
      },
    },
  },

  //  BRASIL
  {
    id: 'sao-paulo',
    country: 'BR',
    bd_city_id: 31,
    civitatis_id: 'sao-paulo',
    main_city_search: true,
    keywords: 'São Paulo, Estado de São Paulo, Brasil',
    geometry: {
      location: {
        lat: -23.5557714,
        lng: -46.6395571,
      },
    },
  },
  {
    id: 'rio-de-janeiro',
    country: 'BR',
    bd_city_id: 29,
    civitatis_id: 'rio-de-janeiro',
    main_city_search: true,
    keywords: 'Rio de Janeiro, Brasil, Cristo Redentor, Corcovado, Pan de Azúcar, Copacabana, Ipanema',
    geometry: {
      location: {
        lat: -22.9068467,
        lng: -43.1728965,
      },
    },
  },
  {
    id: 'porto-alegre',
    country: 'BR',
    bd_city_id: 27,
    keywords: 'Porto Alegre, Brasil, Río Grande del Sur',
    geometry: {
      location: {
        lat: -30.0368176,
        lng: -51.2089887,
      },
    },
  },
  {
    id: 'belo-horizonte',
    country: 'BR',
    bd_city_id: 20,
    keywords: 'Belo Horizonte, Brasil, Minas Gerais, Sierra del Curral, BH, Belô, Ciudad-jardín',
    geometry: {
      location: {
        lat: -19.919052,
        lng: -43.9386685,
      },
    },
  },
  {
    id: 'recife',
    country: 'BR',
    bd_city_id: 28,
    civitatis_id: 'recife',
    keywords: 'Recife, Brasil, Estado de Pernambuco',
    geometry: {
      location: {
        lat: -8.0578381,
        lng: -34.8828969,
      },
    },
  },
  {
    id: 'buzios',
    country: 'BR',
    bd_city_id: 21,
    keywords: 'Búzios, Brasil, Brazil, Armação dos Búzios, Río de Janeiro',
    geometry: {
      location: {
        lat: -22.7553281,
        lng: -41.8833455,
      },
    },
  },
  {
    id: 'salvador-de-bahia',
    country: 'BR',
    bd_city_id: 30,
    civitatis_id: 'salvador-bahia',
    keywords: 'Salvador de Bahía, Brasil, Estado de Bahía, Pelourinho, Aeropuerto Internacional Diputado Luís Eduardo Magalhães',
    geometry: {
      location: {
        lat: -12.9777378,
        lng: -38.5016363,
      },
    },
  },
  {
    id: 'curitiba',
    country: 'BR',
    bd_city_id: 23,
    keywords: 'Curitiba, Brasil, Paraná',
    geometry: {
      location: {
        lat: -25.4372382,
        lng: -49.2699727,
      },
    },
  },
  {
    id: 'florianopolis',
    country: 'BR',
    bd_city_id: 24,
    civitatis_id: 'florianopolis',
    main_city_search: true,
    keywords: 'Florianópolis, Santa Catarina, Brasil',
    geometry: {
      location: {
        lat: -27.5948076,
        lng: -48.5569153,
      },
    },
  },
  {
    id: 'lagoa',
    country: 'BR',
    bd_city_id: 24,
    civitatis_id: 'florianopolis',
    keywords: 'Lagoa (Florianópolis), Lagoa da Conceição, Florianópolis, Santa Catarina, Brasil',
    geometry: {
      location: {
        lat: -27.603092,
        lng: -48.4712296,
      },
    },
  },
  {
    id: 'campeche',
    country: 'BR',
    bd_city_id: 24,
    civitatis_id: 'florianopolis',
    keywords: 'Campeche (Florianópolis), Campeche, Florianópolis, Santa Catarina, Brasil',
    geometry: {
      location: {
        lat: -27.6751968,
        lng: -48.5037206,
      },
    },
  },
  {
    id: 'canasvieiras',
    country: 'BR',
    bd_city_id: 24,
    civitatis_id: 'florianopolis',
    keywords: 'Canasvieiras, Ilha de Santa Catarina, Florianópolis, Brasil',
    geometry: {
      location: {
        lat: -27.4322575,
        lng: -48.4582115,
      },
    },
  },
  {
    id: 'camboriu',
    country: 'BR',
    bd_city_id: 22,
    civitatis_id: 'balneario-camboriu',
    keywords: 'Camboriú, Balneário Camboriú, Santa Catarina, Brasil',
    geometry: {
      location: {
        lat: -27.0217451,
        lng: -48.6515664,
      },
    },
  },
  {
    id: 'fortaleza',
    country: 'BR',
    bd_city_id: 25,
    civitatis_id: 'fortaleza',
    keywords: 'Fortaleza, Ceará, Brasil',
    geometry: {
      location: {
        lat: -3.7327203,
        lng: -38.5270134,
      },
    },
  },
  {
    id: 'manaos',
    country: 'BR',
    bd_city_id: 26,
    civitatis_id: 'manaos',
    keywords: 'Manaos, Amazonas, Brasil',
    geometry: {
      location: {
        lat: -3.1190275,
        lng: -60.0217314,
      },
    },
  },

  // URUGUAY
  {
    id: 'montevideo',
    country: 'UY',
    bd_city_id: 71,
    civitatis_id: 'montevideo',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Montevideo, Departamento de Montevideo, Uruguay',
    geometry: {
      location: {
        lat: -34.9055016,
        lng: -56.1851147,
      },
    },
  },

  // ESPAÑA
  {
    id: 'madrid',
    country: 'ES',
    bd_city_id: 46,
    civitatis_id: 'madrid',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Puerta de Alcalá, Madrid, España, Península ibérica de Europa, Europa',
    geometry: {
      location: {
        lat: 40.4167754,
        lng: -3.7037902,
      },
    },
  },
  {
    id: 'barcelona',
    country: 'ES',
    bd_city_id: 44,
    civitatis_id: 'barcelona',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Barcelona, España, Cataluña, Europa',
    geometry: {
      location: {
        lat: 41.3873974,
        lng: 2.168568,
      },
    },
  },
  {
    id: 'malaga',
    country: 'ES',
    bd_city_id: 47,
    civitatis_id: 'malaga',
    transfer_type_is_ride: true,
    keywords: 'Málaga, España, Andalucía, Europa',
    geometry: {
      location: {
        lat: 36.721261,
        lng: -4.4212655,
      },
    },
  },
  {
    id: 'valencia',
    country: 'ES',
    bd_city_id: 50,
    civitatis_id: 'valencia',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Valencia, València, España, Comunidad Valenciana, Europa',
    geometry: {
      location: {
        lat: 39.4699075,
        lng: -0.3762881,
      },
    },
  },
  {
    id: 'sevilla',
    country: 'ES',
    bd_city_id: 49,
    civitatis_id: 'sevilla',
    main_city_search: true,
    transfer_type_is_ride: true,
    keywords: 'Sevilla, España, Andalucía, Europa',
    geometry: {
      location: {
        lat: 37.3890924,
        lng: -5.9844589,
      },
    },
  },
  {
    id: 'palma',
    country: 'ES',
    bd_city_id: 48,
    civitatis_id: 'palma-mallorca',
    keywords: 'Palma de Mallorca, Mallorca, Islas Baleares, Mediterráneo, España, Europa',
    geometry: {
      location: {
        lat: 39.5696005,
        lng: 2.6501603,
      },
    },
  },
  {
    id: 'cordoba-espana',
    country: 'ES',
    bd_city_id: 45,
    keywords: 'Córdoba, Andalucía, España, Europa',
    geometry: {
      location: {
        lat: 37.8893025,
        lng: -4.779275300000001,
      },
    },
  },
  {
    id: 'ibiza',
    country: 'ES',
    bd_city_id: 73,
    civitatis_id: 'ibiza-ciudad',
    keywords: 'Ibiza, Eivissa, Islas Baleares, Mediterráneo, España',
    geometry: {
      location: {
        lat: 38.9066099,
        lng: 1.4207403,
      },
    },
  },

  // ITALIA
  {
    id: 'roma',
    country: 'IT',
    bd_city_id: 55,
    civitatis_id: 'roma',
    main_city_search: true,
    keywords: 'Roma, Coliseo, Colosseo, Vaticano, Italia, Capilla Sixtina, Cappella Sistina',
    geometry: {
      location: {
        lat: 41.8967068,
        lng: 12.4822025,
      },
    },
  },
  {
    id: 'napoles',
    country: 'IT',
    bd_city_id: 53,
    civitatis_id: 'napoles',
    main_city_search: true,
    keywords: 'Napoli, Nápoles, Italia, Campania',
    geometry: {
      location: {
        lat: 40.8517746,
        lng: 14.2681244,
      },
    },
  },
  {
    id: 'firenze',
    country: 'IT',
    bd_city_id: 51,
    civitatis_id: 'florencia',
    main_city_search: true,
    keywords: 'Florencia, Firenze, Toscana, Italia',
    geometry: {
      location: {
        lat: 43.7699685,
        lng: 11.2576706,
      },
    },
  },
  {
    id: 'milano',
    country: 'IT',
    bd_city_id: 52,
    civitatis_id: 'milan',
    main_city_search: true,
    keywords: 'Milán, Milano, Italia, Lombardía',
    geometry: {
      location: {
        lat: 45.468503,
        lng: 9.182402699999999,
      },
    },
  },
  {
    id: 'pisa',
    country: 'IT',
    bd_city_id: 54,
    civitatis_id: 'pisa',
    main_city_search: true,
    keywords: 'Pisa, Italia, Toscana',
    geometry: {
      location: {
        lat: 43.72283849999999,
        lng: 10.4017581,
      },
    },
  },

  // REINO UNIDO - GRAN BRETAÑA
  {
    id: 'london',
    country: 'GB',
    bd_city_id: 74,
    civitatis_id: 'londres',
    main_city_search: true,
    keywords: 'London, Londres, United Kingdom, Great Britain',
    geometry: {
      location: {
        lat: 51.5072178,
        lng: -0.1275862,
      },
    },
  },

  // PARAGUAY
  {
    id: 'asuncion',
    country: 'PY',
    bd_city_id: 76,
    civitatis_id: 'asuncion',
    main_city_search: true,
    keywords: 'Asunción, Paraguay',
    geometry: {
      location: {
        lat: -25.285074,
        lng: -57.6342317,
      },
    },
  },

  // USA
  {
    id: 'miami',
    country: 'US',
    bd_city_id: 79,
    civitatis_id: 'miami',
    main_city_search: true,
    keywords: 'Miami, USA, United States, Estados Unidos',
    geometry: {
      location: {
        lat: 25.7616798,
        lng: -80.1917902,
      },
    },
  },
];

const citiesForCarousel = {
  // 9 cities per array/country in the order wanted to show
  default: ['buenos-aires', 'rio-de-janeiro', 'cdmx', 'sao-paulo', 'miami', 'madrid', 'roma', 'lima', 'santiago'],
  AR: ['buenos-aires', 'bariloche', 'miami', 'madrid', 'cordoba', 'mendoza', 'rio-de-janeiro', 'ushuaia', 'santiago'],
  BR: ['sao-paulo', 'rio-de-janeiro', 'buenos-aires', 'florianopolis', 'cdmx', 'porto-alegre', 'bogota', 'salvador-de-bahia', 'santiago'],
  CL: ['santiago', 'vina-del-mar', 'buenos-aires', 'miami', 'bariloche', 'rio-de-janeiro', 'cdmx', 'lima', 'madrid'],
  CO: ['bogota', 'medellin', 'panama', 'cdmx', 'santa-marta', 'sao-paulo', 'cartagena', 'quito', 'lima'],
  CR: ['san-jose', 'panama', 'cdmx', 'bogota', 'medellin', 'santo-domingo', 'sao-paulo', 'buenos-aires', 'lima'],
  DO: ['santo-domingo', 'san-jose', 'panama', 'cdmx', 'bogota', 'lima', 'sao-paulo', 'buenos-aires', 'cancun'],
  EC: ['quito', 'guayaquil', 'lima', 'medellin', 'santiago', 'sao-paulo', 'cdmx', 'bogota', 'panama'],
  ES: ['madrid', 'barcelona', 'london', 'roma', 'malaga', 'milano', 'sevilla', 'valencia', 'buenos-aires'],
  FR: ['madrid', 'london', 'barcelona', 'roma', 'malaga', 'cdmx', 'sevilla', 'rio-de-janeiro', 'valencia'],
  GB: ['london', 'madrid', 'barcelona', 'roma', 'malaga', 'firenze', 'napoles', 'rio-de-janeiro', 'valencia'],
  IT: ['roma', 'milano', 'madrid', 'firenze', 'napoles', 'london', 'barcelona', 'cdmx', 'buenos-aires'],
  MX: ['cdmx', 'cancun', 'miami', 'guadalajara', 'playa-del-carmen', 'rio-de-janeiro', 'bogota', 'buenos-aires', 'madrid'],
  PA: ['panama', 'san-jose', 'cdmx', 'bogota', 'lima', 'sao-paulo', 'buenos-aires', 'madrid', 'roma'],
  PE: ['lima', 'cusco', 'quito', 'cdmx', 'santiago', 'buenos-aires', 'sao-paulo', 'madrid', 'roma'],
  US: ['miami', 'london', 'cdmx', 'madrid', 'santo-domingo', 'roma', 'rio-de-janeiro', 'buenos-aires', 'panama'],
  UY: ['montevideo', 'buenos-aires', 'miami', 'rio-de-janeiro', 'bariloche', 'santiago', 'cdmx', 'madrid', 'roma'],
};

// It is sorted alphabetically by name in footer
module.exports = { cities, citiesForCarousel };
